import {memo} from 'react';
import ContactForm from '../components/ContactForm';
import Iframe from '../components/Iframe';
import {useTranslation} from '../hooks';

const Contact = () => {
  const {t} = useTranslation();
  return (
    <section id="contact" className="mt-5">
      <Iframe />

      <h2 className="contact__title">{t('contactTitle')}</h2>
      <ContactForm />
    </section>
  );
};

export default memo(Contact);
